// Pure prev/next swim navigation for the Swim tab (arrows + swipe).
// workouts is most-recent-first: index 0 = latest, higher index = older.
// "prev" = older (higher index); "next" = newer (lower index).
// Stepping "next" onto index 0 selects null (the most-recent / no-uuid path).
import type { WorkoutSummary } from "@contract/types";

export interface SwimNavState {
  canPrev: boolean; // an older swim exists
  canNext: boolean; // a newer swim exists
  prev: string | null; // selection value for the older swim (a uuid), or null if none
  next: string | null; // selection value for the newer swim (uuid, or null = most-recent); meaningful only when canNext
}

export function swimNavState(workouts: WorkoutSummary[], selected: string | null): SwimNavState {
  const found = selected === null ? 0 : workouts.findIndex((wk) => wk.uuid === selected);
  const i = found < 0 ? 0 : found;

  const canPrev = i + 1 < workouts.length;
  const prev = canPrev ? workouts[i + 1].uuid : null;

  const canNext = i > 0;
  const next = canNext ? (i - 1 === 0 ? null : workouts[i - 1].uuid) : null;

  return { canPrev, canNext, prev, next };
}
